import { PropsWithChildren } from "react"
import classNames from "classnames"

export function RecruiterModal({
  children,
  className
}: PropsWithChildren<{ className?: string }>) {
  return (
    <div className="backdrop-blur-md fixed top-0 w-full h-full z-10 flex justify-center items-center">
      <div
        className={classNames(
          "w-full max-w-[480px] p-12 bg-white rounded-3xl",
          className
        )}
      >
        {children}
      </div>
    </div>
  )
}
